import React, { useEffect, useState } from 'react';
import config from '../config/config'; // Import der Konfigurationsdatei
import { Card, CardHeader, CardTitle, CardBody, CardImage, CardSubtitle, Avatar } from '@progress/kendo-react-layout';
import styled from 'styled-components';
import { Button } from '@progress/kendo-react-buttons';
import { trashIcon } from '@progress/kendo-svg-icons';
import axios from 'axios';
import { useForm } from '../contexts/FormContext';
import { ProgressBar } from '@progress/kendo-react-progressbars'; // ✅ Korrekte ProgressBar-Import
import GetUserAvatar from '../components/GetUserAvatar';

const avatarImage = 'https://demos.telerik.com/blazor-ui/images/stack-layout/avatar1.jpg';

const StyledButton = styled(Button)`
    
    font-weight: bold;
    font-size: 20px;
`;

const ModuleStep5: React.FC = () => {
    const { formData } = useForm();
    const [imagePreviews, setImagePreviews] = useState<string[]>([]);
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [isUploading, setIsUploading] = useState<boolean>(false);

    useEffect(() => {
        if (!formData.jobID) return;

        axios.get(`${config.host}/jobs/${encodeURIComponent(formData.jobID)}`)
            .then(response => {
                const jobData = response.data;
                if (jobData.Media) {
                    setImagePreviews(jobData.Media);
                }
            })
            .catch(error => console.error("❌ Fehler beim Laden der Bilder:", error));
    }, [formData.jobID]);

    const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;

        setIsUploading(true);
        setUploadProgress(0);

        const formDataUpload = new FormData();
        Array.from(files).forEach((file) => {
            formDataUpload.append("file", file);
        });

        try {
            const response = await axios.post(
                `${config.host}/upload/${encodeURIComponent(formData.jobID)}`,
                formDataUpload,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (progressEvent) => {
                        const total = progressEvent.total ?? progressEvent.loaded; // ✅ Absicherung gegen undefined
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / total);
                        setUploadProgress(percentCompleted);
                    }
                }
            );

            const uploadedUrls = response.data.urls;
            setImagePreviews((prevPreviews) => [...prevPreviews, ...uploadedUrls]);
        } catch (error) {
            console.error("❌ Fehler beim Hochladen der Bilder:", error);
        } finally {
            setTimeout(() => setIsUploading(false), 1000);
        }
    };

    const handleButtonClick = () => {
        document.getElementById('file-input')?.click();
    };

    const removeImage = async (index: number) => {
      const imageUrl = imagePreviews[index];
  
      try {
          await axios.delete(`${config.host}/delete-image/${encodeURIComponent(formData.jobID)}`, {
              headers: { 
                  "Content-Type": "application/json"
              },
              data: { url: imageUrl }  // 🔹 DELETE-Requests erwarten oft "data"
          });
  
          setImagePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
      } catch (error) {
          console.error("❌ Fehler beim Löschen des Bildes:", error);
      }
  };
  

    return (
        <div style={{ padding: '20px', position: 'relative' }}>
            {/* 🔹 Loader mit Overlay */}
            {isUploading && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '10px', textAlign: 'center', width: '300px' }}>
                        <p style={{ marginBottom: '10px' }}>Upload läuft...</p>
                        <ProgressBar value={uploadProgress} style={{ width: '100%' }} />
                        <p style={{ marginTop: '10px' }}>{uploadProgress}%</p>
                    </div>
                </div>
            )}

            <Card orientation="vertical" className="custom-card">
                <CardHeader className="k-hbox custom-card-header">
                    <GetUserAvatar />
                    <div>
                        <CardTitle>Step 5: Foto Hochladen</CardTitle>
                        <CardSubtitle>Laden Sie mehrere Fotos vom iPad hoch</CardSubtitle>
                    </div>
                </CardHeader>
                <CardBody>
                    <div style={{ marginBottom: '20px' }}>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                            multiple
                            id="file-input"
                            style={{ display: 'none' }}
                        />
                        <StyledButton
                            themeColor="primary"
                            onClick={handleButtonClick}
                            style={{ width: '100%', marginTop: '20px', marginBottom: '20px' }}
                        >
                            Dateien auswählen
                        </StyledButton>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'center' }}>
                        {imagePreviews.map((src, index) => (
                            <Card key={index} style={{ width: 260, boxShadow: '0 0 4px 0 rgba(0, 0, 0, .1)' }}>
                                <CardImage src={src} style={{ height: '185px', maxWidth: '100%' }} />
                                <CardBody style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <CardTitle style={{ marginBottom: '4px' }}>Bild {index + 1}</CardTitle>
                                    <Button
                                        fillMode="flat"
                                        onClick={() => removeImage(index)}
                                        svgIcon={trashIcon}
                                    />
                                </CardBody>
                            </Card>
                        ))}
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default ModuleStep5;
